import router from './router/index';
import store from './store/index';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式
import { getToken } from '@/utils/auth';
import { constantRouters, asyncRouters } from './router/index';
import h5router from '@/utils/h5router.js';
import { judgeObj } from '@/utils/index.js';

function findUrl(url, urlList) {
	var flag = false;
	for (let index = 0; index < urlList.length; index++) {
		if (flag) {
			break;
		}
		const element = urlList[index];
		if (element.name == url.name) {
			flag = true;
			break;
		} else if (!flag && element.children) {
			flag = findUrl(url, element.children);
		}
	}
	return flag;
}

function hasPermission(toRouter) {
	//判断是否有进入权限
	let routerList = constantRouters.concat(asyncRouters);

	if (findUrl(toRouter, routerList) && !findUrl(toRouter, store.getters.permission_routers)) {
		return false;
	}
	return true;
}
router.beforeEach((to, from, next) => {
	// H5路由判断
	let judgeVal = h5router();
	if (!judgeVal) {
		next();
		return false;
	}

	if (to.path === from.path && judgeObj(to.query, from.query)) {
		next(false);
	}

	NProgress.start();
	next();
	NProgress.done();
	if (getToken()) {
		if (!store.getters.name) {
			store
				.dispatch('GetUserInfo')
				.then(() => {
					// 拉取用户信息
					next();
				})
				.catch(() => {
					store.dispatch('FedLogOut');
				});
		} else {
			if (hasPermission(to)) {
				next();
			} else {
				next({
					path: '/401',
					name: 'Err401',
					replace: true,
					query: {
						noGoBack: true,
					},
				});
			}
			//   next()
		}
		// }
	} else {
		store.dispatch('FedLogOut');
		NProgress.done();
	}
});

router.afterEach(() => {
	NProgress.done(); // 结束Progress
});
